{
  "responseShape": "Phản hồi của máy chủ không khớp với định dạng mong đợi — vui lòng làm mới.",
  "badRequest": "Yêu cầu không hợp lệ. Vui lòng kiểm tra dữ liệu nhập.",
  "forbidden": "Bạn không có quyền thực hiện thao tác này.",
  "facilityRequired": "Chọn một cơ sở trên thanh tiêu đề để sử dụng mô-đun này.",
  "notFound": "Không tìm thấy tài nguyên.",
  "conflict": "Tài nguyên đã tồn tại.",
  "validation": "Lỗi xác thực.",
  "tooManyRequests": "Quá nhiều yêu cầu. Vui lòng thử lại sau.",
  "serverError": "Lỗi máy chủ. Vui lòng thử lại sau.",
  "unexpected": "Đã xảy ra lỗi không mong muốn.",
  "network": "Lỗi mạng. Vui lòng kiểm tra kết nối của bạn.",
  "requestSetup": "Đã xảy ra lỗi. Vui lòng thử lại.",
  "sessionExpired": "Phiên của bạn đã hết hạn. Vui lòng đăng nhập lại."
}
